import TambahSeleksiVendor from './TambahSeleksiVendor'

export default TambahSeleksiVendor